import { useEffect } from 'react'

const LOCK_CLASS = 'brc-scroll-lock'

function clearScrollLock() {
  if (typeof document === 'undefined') return
  document.documentElement.classList.remove(LOCK_CLASS)
  document.body.classList.remove(LOCK_CLASS)
}

/** Prevent background scroll while a full-screen mobile overlay is open. */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) {
      clearScrollLock()
      return
    }

    const { documentElement, body } = document
    documentElement.classList.add(LOCK_CLASS)
    body.classList.add(LOCK_CLASS)

    return clearScrollLock
  }, [locked])

  // Safety: clear lock if this component unmounts while chat was open (e.g. route change).
  useEffect(() => () => clearScrollLock(), [])
}
